import React from "react";
import { Input } from "@windmill/react-ui";

const InputAreaSmall = ({
  register,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  value,
  readOnly,
  onChangeFunction,
  myPriceRef,
  maxLength,
}) => {
  const handleInput = (e) => {
    const inputValue = e.target.value;
    if (inputValue.length > maxLength) {
      e.target.value = inputValue.slice(0, maxLength);
      return;
    }
    let val = e.target.value;
    if (val !== null && val !== undefined) {
      val = val.replace(/[^0-9]/g, "");
    }
    e.target.value = val;
  };
  return (
    <>
      <Input
        //  style={{ width: '100px'}}
        {...register(name, {
          required: value ? false : `${label} is required!`, // Validation rule
        })}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        name={name}
        maxLength={maxLength}
        onInput={handleInput}
        onChange={(e) => onChangeFunction(e)}
        value={value}
        ref={myPriceRef}
        onWheel={(e) => e.preventDefault()}
        step="any"
        autoComplete="off"
        readOnly={readOnly}
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      />
    </>
  );
};

export default InputAreaSmall;
